<template>
  <!-- <div>
    <Suspense>
      <template #fallback>
          <div>loading</div>
      </template>

      <AsyncLichessStream :lichessURL="lichessURLEventStream" :accessToken="lichessAccessToken"
              :isDone="isDoneWithLichessStream"
              @controller-callback="saveEventStreamControllerCallback"
              @received-string="receivedEventString" />  

    </Suspense>
  </div> -->

  <ion-page id="lichess-challenge-page">
    <ion-content>
      <div class="center" :class="{ 'text-light' : !isDark,'text-dark' : isDark }" 
                            :style="styleChallenge">
        <!-- <div v-if="isFriendChallenge" style="height : 75px;overflow-y:scroll;">
          <div v-for="item in onlineFriends" v-bind:key="item.index">
            <div @click="onFriendClick(item.index)">
              {{ t("On") }} : {{ item.name }}
            </div>
          </div>
          <hr>
          <div v-for="item in offlineFriends" v-bind:key="item.index">
            {{ t("Off") }} : {{ item.name }}
          </div>
        </div> -->
        <p></p>
        <hr>
        <div>
          {{ challengeTitle }}
        </div>
        <div v-html="parameterString"></div>
        <br>
        <b>
        <!-- <div v-html="statusString"> -->
        <button @click="toolbarClick(TOOLBAR_CHALLENGE)" class="btn btn-padding">{{  statusString }}
        </button>
        </b>
      </div>
      <div v-if="!showBigButtons">
        <ActionSheet :heading="optionsHeadingString" :items="actionSheetButtons" 
                    :trigger="actionSheetTrigger"
                    @action-sheet-result="actionSheetResult">
        </ActionSheet>
      </div>
    </ion-content>
    <Toolbar :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
  </ion-page>
</template>

<script setup>

  import { IonAlert,IonIcon,IonPage, IonContent,modalController  } from '@ionic/vue';

  import { ref, watch, onBeforeUnmount } from 'vue'
  import Toolbar from '@/components/Toolbar.vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import AsyncLichessStream from '@/components/AsyncLichessStream.vue'
  import ActionSheet from '@/components/ActionSheet.vue'

  import ModalGenericSingleList from '@/components/ModalGenericSingleList.vue'
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
  import ModalActionReplacement from '@/components/ModalActionReplacement.vue';

  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { useGetData , getLichessData, generateErrorAlertText, Utf8ArrayToStr } from '../../composables/getData.js'
  import { matchValue } from '@/composables/wordlistSupport.js'
  import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'
  import { t , replaceMultipleAll } from '@/composables/translateText.js'

  import { useStringStore } from '@/stores/stringStore';

  const emit = defineEmits(['next-item-click'])

  const connectionStore = useConnectionStore()
  var challengeType = connectionStore.getProductOption

  const whichMenu = localStorage.getItem("whichMenu")
  const showBigButtons = ref(whichMenu == "buttons" || connectionStore.getShowBigButtons)
  const showEyegazeButtons = ref(connectionStore.getIsEyeGaze)

  var isDoneWithLichessStream = false

  const isFriendChallenge = ref(challengeType == "friend")
  const lichessAccessToken = connectionStore.getLichessAccessToken

  var hasActiveLichessStream = false

  const stringStore = useStringStore()

  const optionsHeadingString = ref(t("Options"))

  //console.log("access token in challenge",lichessAccessToken)
  var challengeIssued = false

  const lichessURLEventStream = "https://lichess.org/api/stream/event"

  const parameterString = ref("")
  const statusString = ref("")

  const onlineFriends = ref([])
  const offlineFriends = ref([])
  const friendName = ref(t("Select Online Friend"))
  var friendId = ""

  const challengeTitle = ref("Unknown")

  const isDark = ref(connectionStore.getDarkmode != "light")
  
  const menuTrigger = ref(0)

  const TOOLBAR_CHALLENGE = 0
  const TOOLBAR_OPTIONS = 1
  const TOOLBAR_DONE = 2

  const ACTION_COLOR_TO_PLAY = 11
  const ACTION_TIME_CONTROL = 12
  const ACTION_RATED_GAME = 13
  const ACTION_BOT = 14

  const toolbarElements = ref([
    { index : TOOLBAR_CHALLENGE, label : t("Challenge") ,disabled : false},
    { index : TOOLBAR_OPTIONS, label : t("Options") ,disabled : false, hasAction : true }
  ])

  if (whichMenu == "buttons")
    toolbarElements.value.push({ index : TOOLBAR_DONE, label : t("Done") , disabled : false})

  const toolbarTrigger = ref(0)

  const actionSheetTrigger = ref(0)
  var actionSheetButtons = []

  // OPTIONS
   
  var colorStrings = [t("Random Color"),t("Play as White"), t("Play as Black")]
  var colorValues = [ "r", "w" , "b" ]
  var currentColor = ""
  var colorName = ""

  var ratedStrings = [t("Yes"),t("No")]
  var ratedValues = [ 1, 0 ]
  var currentRated = ""
  var ratedName = ""

  const minutesString = t("minutes")
  const incrementString = t("sec increment")
  const noincrementString = t("no increment")
  var timeControlStrings = [
          "5 " + minutesString + " , 5 " + incrementString,
					"10 " + minutesString + " , " + noincrementString,
          "10 " + minutesString + " , 5 " + incrementString,
					"15 " + minutesString + " , 10 " + incrementString, 
          "30 " + minutesString + " , " + noincrementString,
					"30 " + minutesString + " , 20 " + incrementString, 
          "30 " + minutesString + " , 30 " + incrementString,
					"45 " + minutesString + " , 45 " + incrementString]
  var timeControlValues = [ 505,1000,1005,1510,3000,3020,3030,4545 ]
  var currentTimeControl = ""
  var timeControlName = ""

  var correspondenceStrings = ["1 " + t("day"), "3 " + t("days"), "5 " + t("days"), "7 " + t("days"), "14 " + t("days")]
  var correspondenceValues = [ 1,3,5,7,14 ]
  var currentCorrespondence = ""
  var correspondenceName = ""

   // which option is being worked on in generic list
   var whichOptionIsGenericList = ""
   var singleOptionServerField = ""

  var optionDisplayArray = []
  var optionDisplaySelected = ""
  var optionHeading = ""
  var optionDisplay = []


  const styleChallenge = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  // callback for stream processing
  var eventStreamController = null
  var eventStreamAbortCallback = null

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  var controller = null

  setupFetch(lichessURLEventStream,lichessAccessToken)

  setTopLine()
  buildActionSheetButtons()
  doStartupCheck(false,afterStartupCallbackRoutine)

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
    updateWidthHeights()
    if (isFriendChallenge.value) {
      toolbarElements.value[TOOLBAR_CHALLENGE].disabled = true
      toolbarElements.value[TOOLBAR_OPTIONS].disabled = true
      getFriends()
    }
    else
      getOptions("display")
    menuTrigger.value++
  }

  watch(() => connectionStore.getLichessOption, () => {
    //console.log("#################### lichessoption changed ")
    challengeType = connectionStore.getLichessOption
    //console.log("challenge type flag ",challengeType)

    displayStatus()
    setTopLine()
    buildActionSheetButtons()
  })

  watch(() => windowSizeStore.getWindowSize, () => {
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    updateWidthHeights()
    menuTrigger.value++
  })

  function updateStyleObjects(boundaries) {
    styleChallenge.value.height = boundaries['challenge'].height + "px"
    styleChallenge.value.width = boundaries['challenge'].width + "px"
    styleChallenge.value.top = boundaries['challenge'].top + "px"
    styleChallenge.value.left = boundaries['challenge'].left + "px"
  }

  function updateWidthHeights() {
    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                      calculateLandscapeWidthHeights(availableSpace)
    
    updateStyleObjects(boundaries)
  }

  function calculatePortraitWidthHeights(availableSpace) {
    const challengePositionTop = 0
    const challengePositionLeft = availableSpace.leftRightIndent
    const challengeHeight = availableSpace.height - challengePositionTop
    const challengeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { 
      challenge : {
        width : challengeWidth,
        height : challengeHeight,
        left : challengePositionLeft + availableSpace.leftIndent,
        top : challengePositionTop+ availableSpace.topIndent
      }
    }
    //console.log("board and movelist dimensions",result)
    return (result)
  }

  function calculateLandscapeWidthHeights(availableSpace) {

    const challengePositionTop = 0
    const challengePositionLeft = availableSpace.leftRightIndent
    const challengeHeight = availableSpace.height - challengePositionTop
    const challengeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = {
      challenge : {
        width : challengeWidth,
        height : challengeHeight,
        left : challengePositionLeft + availableSpace.leftIndent,
        top : challengePositionTop+ availableSpace.topIndent
      }
    }
    return (result)
  }

  function actionSheetResult(action,index) {
    //console.log("in action sheet result",action,index)
    if (action != "yes")
      return
    actionClick(index)
  }

  function buildActionSheetButtons() {
    const currentTimeString = (challengeType == "correspondence") ? correspondenceName : timeControlName
    actionSheetButtons = []
    actionSheetButtons.push({ text : t("Color You Play"), code : "color",
                                  current: colorName, data : { index : ACTION_COLOR_TO_PLAY }})
    actionSheetButtons.push({ text : t("Time Control") ,  code : "timecontrol",
                                  current: currentTimeString, data : { index : ACTION_TIME_CONTROL }})
    actionSheetButtons.push({ text : t("Rated Game?"),  code : "rated",
                                  current: ratedName, data : { index : ACTION_RATED_GAME }})
  }

  function saveEventStreamControllerCallback(abortFunction,controllerName) {
    //console.log("**** In Event Stream Save Controller",abortFunction,controllerName)
    eventStreamController = controllerName
    eventStreamAbortCallback = abortFunction
  
  }

  // START ****************** MOVED FROM AsyncLichessStream

  function abortFunction(controller) {
    //console.log("******* IN Abort Function",controller)
    if (controller != null) {
      try {
        controller.abort()
      }
      catch (error) {
        //console.log("abort error",error)
      }
    }
    controller = null
    //console.log("end abort function")
  }

  async function setupFetch (url,accessToken) {
    if (url == "" || accessToken == "")
      return

    //console.log("SETUP FETCH",url,accessToken)

    controller = new AbortController()

    var response = null
    try {
      response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept' : 'application/json',
          'Authorization' : "Bearer " + accessToken
        },
        signal : controller.signal
      })
    }
    catch(error) {
      console.error('Error:', error);
    }

    const reader = (response == null) ? null : response.body.getReader();

    // check if we're done with the stream on each loop. Calling program sets 'isDone'
    while (reader != null && controller != null && isDoneWithLichessStream == false) {
      const {value, done} = await reader.read();
      if (controller == null || done) 
        break;
      const receivedString = Utf8ArrayToStr(value)
      receivedEventString(receivedString)
      //console.log('Received', receivedString,value,isDoneWithLichessStream);
    }

    receivedEventString("ABORT")
    //console.log("before abort call")
    abortFunction(controller)
    //console.log('Response fully received');
   
  }

  // END ****************** MOVED FROM AsyncLichessStream

  function receivedEventString(string) {
    //console.log("***** GOT EVENT STRING ->",challengeIssued,string)

    // The event stream has to finish before we leave the screen
    if (string == "ABORT") {
      hasActiveLichessStream = false
      // timer will send them to calling View
      return
    }

    hasActiveLichessStream = true

    // getting all the stream traffic so we know it is alive
    if (string == "\n")
      return

    // ignore any strings until "Challenge" issued.  (can be list of already open games)
    if (challengeIssued == false)
      return

    const events = string.split("\n");
    //console.log("***** Events",events)
    if (events.length == 0)
      return;
    for (var i=0; i < events.length; i++) {
      if (events[i].length == 0)
        continue
      const oneEvent = JSON.parse(events[i])
      //console.log("*** event ",i,oneEvent)
      if (oneEvent.hasOwnProperty('type')) {
        switch (oneEvent['type']) {
          case "gameStart" :
            statusString.value = "Challenge Accepted!"
            const oneGame = oneEvent['game']
            const gameId = oneGame['gameId']
            //console.log("*** one game",oneGame)
            //console.log("**** game ID",gameId)
            playGame(gameId)
            break
          case "gameFinish" :
            break
          case "challenge" :
            break
          case "challengeCanceled" :
            break
          case "challengeDeclined" :
            statusString.value = "Challenge Declined"
            break
        }
      }
  
    }
  }

  onBeforeUnmount(() => {
    //console.log("**************** Lichess Challenge unmounted")
    
    isDoneWithLichessStream = true

    // used for the client doing the event stream
    //if (eventStreamAbortCallback != null)
    //  eventStreamAbortCallback(eventStreamController)

  })

  function onFriendClick(index) {
    friendId = onlineFriends.value[index].userid
    friendName.value = onlineFriends.value[index].name
    //console.log("selected friend: ",friendId,friendName.value)
    toolbarElements.value[TOOLBAR_CHALLENGE].disabled = false
    toolbarElements.value[TOOLBAR_OPTIONS].disabled = false
    challengeTitle.value = t("Challenge Friend") + ": " + friendName.value
  }

  function toolbarClick(arrayIndex) {
    //console.log("toolbar click ",arrayIndex)

    // trap that the button should be disabled but the screen hasn't caught up
    if (arrayIndex < 10 && toolbarElements.value[arrayIndex].disabled)
      return

    switch (arrayIndex) {
      case TOOLBAR_DONE :
        emit("next-item-click","big_button_menu",t("Big Button Menu"),"buttons")
        break
      case TOOLBAR_OPTIONS :
        if (showBigButtons.value)
          openActionReplacementModal()
        else
          actionSheetTrigger.value++
        break
      case TOOLBAR_CHALLENGE :
        toolbarElements.value[TOOLBAR_CHALLENGE].disabled = true
        toolbarElements.value[TOOLBAR_OPTIONS].disabled = true
        statusString.value = "*** " + t("Challenge Issued") + " ***"
        switch (challengeType) {
          case "rapid" :
            sendRapidChallenge()
            break
          case "friend" :
            sendFriendChallenge()
            break
          case "correspondence" :
            sendCorrespondenceChallenge()
            break
          case "bot" :
            sendBotChallenge()
            break
        }
        break
    }
  }

  function actionClick(index) {
    switch (index) {
    case ACTION_BOT :
        getOptions("bot")
        break
      case ACTION_COLOR_TO_PLAY :
        getOptions("color")
        break
      case ACTION_TIME_CONTROL :
        getOptions("time")
        break
      case ACTION_RATED_GAME :
        getOptions("rated")
        break
    }
  }

  function setTopLine() {
    //console.log("CHALLENGE TYPE",challengeType)
    switch (challengeType) {
      case "rapid" :
        challengeTitle.value = t("Rapid Challenge")
        break
      case "correspondence" :
        challengeTitle.value = t("Correspondence Challenge")
        break
      case "bot" :
        challengeTitle.value = t("BOT Challenge")
        break
      case "friend" :
        challengeTitle.value = t("Challenge Friend") + ": " + friendName.value
        break 
    }
  }

  function displayStatus() {
    //console.log("in display status  challenge type",challengeType)
    parameterString.value = ""
    switch (challengeType) {
    case "friend" :
    case "rapid" :
        parameterString.value = colorName + "<br>" + timeControlName + "<br>" + t("Rated") + ": " + ratedName
        break
    case "correspondence" :
        parameterString.value = colorName + "<br>" + correspondenceName + "<br>" + t("Rated") + ": " + ratedName 
        break
    case "bot" :
        parameterString.value = colorName+ "<br>" + timeControlName + "<br>" + t("Rated") + ": " + ratedName 
        break
    default :
        break
    }
    if (showEyegazeButtons.value)
      parameterString.value += "<br>" + t("Using EyeGaze Buttons")
    statusString.value = t("Issue Challenge") + "?"
  }
    
   // START ACTION SHEET REPLACMENT

   function delayBeforeShowingOption(optionId) {

    let timerSleepAmount = 250

    function oneInterval() {
      clearInterval(id)
      actionSheetResult("yes",optionId)
    }
    var id = setInterval(oneInterval, timerSleepAmount)
  }

 const openActionReplacementModal = async () => {
    buildActionSheetButtons()

    const modal = await modalController.create({
      component: ModalActionReplacement,
      componentProps: {
        displayArray : actionSheetButtons,
        title : t("Options")  
       }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    //console.log("action replacement",data,role)
    if (role === 'selected') {
      delayBeforeShowingOption(data)
    }
  };

  // END ACTION SHEET REPLACEMENT

  // START Generic Options List

  const openGenericSingleListModal = async () => {
    const modal = await modalController.create({
      component: ModalGenericSingleList,
      componentProps: {
        displayArray : optionDisplayArray,
        initialValue : optionDisplaySelected,
        title : optionHeading      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    //console.log("which generic list",whichOptionIsGenericList)

    //console.log("CONFIRM in static",data,role)

    // for selecting friend, okay with them hitting "cancel"
    if (role === 'confirm' || whichOptionIsGenericList == "friend") {
      // did user leave the select the same?
      if (whichOptionIsGenericList != "friend" && data.selected == optionDisplaySelected)
        return


      switch (whichOptionIsGenericList) {
      case "friend" :
        //console.log("friend",data.selected)
        onFriendClick(data.selected)
        break
      case "bot" :
        currentBot = data.selected
        setOption(singleOptionServerField,data.selected)
        break;
      case "time" :
        currentTimeControl = data.selected
        setOption(singleOptionServerField,data.selected)
        break;
      case "rated" :
        currentRated = data.selected
        setOption(singleOptionServerField,data.selected)
        break
      case "color" :
        currentColor = data.selected
        setOption(singleOptionServerField,data.selected)
        break
    }
    //console.log("lichess challenge option value changed",singleOptionServerField,id)

   }
  }

  function processOptionsJsonResponse (json) {
    console.log(" in lichess options callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    currentColor = json["color_initial"]
    colorName = matchValue(currentColor,colorValues,colorStrings)
    currentRated = json["rated_initial"]
    ratedName = matchValue(currentRated,ratedValues,ratedStrings)

    let timeControlInt = json["time_control_initial"]
    currentTimeControl = String(timeControlInt)
    timeControlName = matchValue(currentTimeControl,timeControlValues,timeControlStrings)

    currentCorrespondence = json["correspondence_initial"]
    correspondenceName = matchValue(currentCorrespondence,correspondenceValues,
                      correspondenceStrings)
  
    var display_text = []
    var values = []
    var initial = ""

    //console.log("*** json wich option",whichOptionIsGenericList)
    switch (whichOptionIsGenericList) {
      case "display" :
      case "friend" :
        displayStatus()
        return
      case "time" :
        optionHeading = t("Time Control")
        display_text = (challengeType == "correspondence") ? correspondenceStrings : timeControlStrings
        values = (challengeType == "correspondence") ? correspondenceValues : timeControlValues
        initial = (challengeType == "correspondence") ? currentCorrespondence : currentTimeControl
        singleOptionServerField = (challengeType == "correspondence") ?  "correspondence" : "time_control"
        break;
      case "rated" :
        optionHeading = t("Rated Game?")
        display_text = ratedStrings
        values = ratedValues
        initial = currentRated
        singleOptionServerField = "rated"
        break;
      case "color" :
        optionHeading = t("Color You Play")
        display_text = colorStrings
        values = colorValues
        initial = currentColor
        singleOptionServerField = "color"
        break
    }

    optionDisplayArray = []
    for (var i=0; i < display_text.length; i++) {
      const oneItem = { 
        index : i,
        name : display_text[i],
        id : values[i],
        radio : "" + values[i]
      }
      optionDisplayArray.push(oneItem)
    }

    optionDisplaySelected = "" + initial

    openGenericSingleListModal()

    //setupOptionsScreen(display_text,values,initial)

  }
  
  function getOptions(whichOption) {
    whichOptionIsGenericList = whichOption
    optionDisplayArray = []

    var formData = { 
    }

    useGetData("chessvis_get_lichess_options.php", formData, processOptionsJsonResponse)
  }

  function processSetOptionJsonResponse (json) {
    //console.log(" in set option callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
    getOptions("display")
  }

  function setOption(fieldName,value) {
    var formData = {
      name : fieldName,
      value : value
    }

    //console.log("Set Option ",formData)
    useGetData("chessvis_set_lichess_options.php", formData,processSetOptionJsonResponse)
  }

  function processRapidGameJsonResponse (json) {
    //console.log(" in rapid game callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    if (json.hasOwnProperty("gameid")) {
      toolbarElements.value[TOOLBAR_CHALLENGE].disabled = false
      toolbarElements.value[TOOLBAR_OPTIONS].disabled = false
      toolbarTrigger.value++
      statusString.value = "Game Created"
      const gameId = json['gameid']
      //console.log("game created! ",gameId)
      playGame(gameId)
    }
    else {
      toolbarElements.value[TOOLBAR_CHALLENGE].disabled = false
      toolbarElements.value[TOOLBAR_OPTIONS].disabled = false
      toolbarTrigger.value++
      statusString.value = "Game Not Created"
    }
  }

  function sendBotChallenge() {
          
    const ratedString = (currentRated == "1") ? "true" : "false"
    var colorString = "random"
    var botName = "ai"
    var botLevel = "1"
    var postData = ""
    var urlStr = "https://lichess.org/api/challenge/"
    
    if (currentColor == "w") {
        colorString = "white"
    }
    else
        if (currentColor == "b") {
            colorString = "black"
        }

    const timeControl = parseInt(currentTimeControl)
    const minutes = Math.floor(timeControl / 100)
    const seconds = minutes * 60
    const increment = timeControl % 100

    var formData = {
      level : botLevel,
      color : colorString,
      rated : ratedString,
      "clock.limit" : seconds,
      "clock.increment" : increment
    }
    urlStr += botName;
        
    //console.log("URL",urlStr)
    //console.log("accesstoken",lichessAccessToken)

    challengeIssued = true

    getLichessData(urlStr, lichessAccessToken,formData, processLichessBotChallengeResponse) 
  }

  function processLichessBotChallengeResponse(json) {
    toolbarElements.value[TOOLBAR_CHALLENGE].disabled = false
    toolbarElements.value[TOOLBAR_OPTIONS].disabled = false
    toolbarTrigger.value++

    if (json.hasOwnProperty('id')) {
      const gameId = json['id']
      playGame(gameId)
    }
  }

  function processFriendChallengeResponse(json) {
    //console.log("************   Friend Challenge Response",json)
    toolbarElements.value[TOOLBAR_CHALLENGE].disabled = false
    toolbarElements.value[TOOLBAR_OPTIONS].disabled = false
    toolbarTrigger.value++
  }

  function processRapidChallengeResponse(json) {
    //console.log("************   Rapid Challenge Response",json)
    toolbarElements.value[TOOLBAR_CHALLENGE].disabled = false
    toolbarElements.value[TOOLBAR_OPTIONS].disabled = false
    toolbarTrigger.value++
    statusString.value = "*** Send Challenge Again? ***"
  }

  function startFriendChallengeTimer() {
    const timerSleepAmount = 21000

    function oneInterval() {
      clearInterval(id)
      toolbarElements.value[TOOLBAR_CHALLENGE].disabled = false
      toolbarElements.value[TOOLBAR_OPTIONS].disabled = false
      toolbarTrigger.value++
      statusString.value = "*** " + t("Challenge Expired.  Send Again?") + " ***"
    }
    var id = setInterval(oneInterval, timerSleepAmount)
  }

  // send Friend challenges straight to lichess.org
  function sendFriendChallenge() {
          
    const ratedString = (currentRated == "1") ? "true" : "false"
    var colorString = "random"
    var postData = ""
    var urlStr = "https://lichess.org/api/challenge/" + friendId
    
    if (currentColor == "w")
      colorString = "white"
    else
    if (currentColor == "b")
      colorString = "black"
      
    const timeControl = parseInt(currentTimeControl)
    const minutes = Math.floor(timeControl / 100)
    const seconds = minutes * 60
    const increment = timeControl % 100

    var formData = {
      color : colorString,
      rated : ratedString,
      "clock.limit" : seconds,
      "clock.increment" : increment
    }
        
    //console.log("URL",urlStr)
    //console.log("accesstoken",lichessAccessToken)

    challengeIssued = true
    startFriendChallengeTimer()
    getLichessData(urlStr, lichessAccessToken,formData, processFriendChallengeResponse) 
  }

  function sendRapidChallenge() {
          
    const ratedString = (currentRated == "1") ? "true" : "false"
    var colorString = "random"
    var postData = ""
    var urlStr = "https://lichess.org/api/board/seek"
    
    if (currentColor == "w")
      colorString = "white"
    else
    if (currentColor == "b")
      colorString = "black"
      
    const timeControl = parseInt(currentTimeControl)
    const minutes = Math.floor(timeControl / 100)
    const seconds = minutes * 60
    const increment = timeControl % 100

    var formData = {
      color : colorString,
      rated : ratedString,
      "time" : minutes,
      "increment" : increment
    }
        
    //console.log("URL",urlStr)
    //console.log("accesstoken",lichessAccessToken)
    challengeIssued = true

    getLichessData(urlStr, lichessAccessToken,formData, processRapidChallengeResponse) 
  }

  function playGame(gameId) {
    connectionStore.setLichessGameId(gameId)
    emit("next-item-click","lichess_play","Lichess Play","lichess")
  }

  // this comes back from lichess.org
  function processLichessCorrespondenceChallengeResponse(json) {
    //console.log(" in lichess correspondence challenge callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    statusString.value = t("When Challenge Accepted, it will be in your 'Open Games' list")
    toolbarElements.value[TOOLBAR_CHALLENGE].disabled = false
    toolbarElements.value[TOOLBAR_OPTIONS].disabled = false
    toolbarTrigger.value++
  }

  // send correspondence challenges straight to lichess.org
  function sendCorrespondenceChallenge() {
          
    const ratedString = (currentRated == "1") ? "true" : "false"
    var colorString = "random"
    var postData = ""
    var urlStr = "https://lichess.org/api/board/seek"
    
    if (currentColor == "w")
        colorString = "white"
    else
    if (currentColor == "b")
        colorString = "black"

    const days = parseInt(currentCorrespondence)

    var formData = {
      color : colorString,
      rated : ratedString,
      days : days
    }        
    //console.log("URL",urlStr)
    //console.log("accesstoken",lichessAccessToken)
    //console.log("formdata",formData)
    challengeIssued = true

    getLichessData(urlStr, lichessAccessToken,formData, processLichessCorrespondenceChallengeResponse) 
  }

  function processFriendGameJsonResponse (json) {
    //console.log(" in friend game callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    toolbarElements.value[TOOLBAR_CHALLENGE].disabled = false
    toolbarElements.value[TOOLBAR_OPTIONS].disabled = false
    toolbarTrigger.value++

    if (json.hasOwnProperty("gameid")) {
      const gameId = json['gameid']
      if (gameId == "DECLINE")
        statusString.value = t("Challenge Declined")
      else {
        statusString.value = t("Challenge Accepted")
        //console.log("game created! ",gameId)
        playGame(gameId)
      }
    }
    else
      statusString.value = t("No Response")
  }


  function processJsonResponse (json) {
    //console.log(" in lichess friends callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    if (json.length == 0) {
      getOptions("display")
      return
    }

    var ids = []
    const friends = json.split("\n");
    //console.log("***** Friends",friends)
    if (friends.length == 0) {
      getOptions("display")
      return
    }
    for (var i=0; i < friends.length; i++) {
      if (friends[i].length == 0)
        continue
      const oneFriend = JSON.parse(friends[i])
      if (oneFriend.hasOwnProperty('id'))
        ids.push(oneFriend['id'])
      //console.log("**** Friend ",i,oneFriend)
    }

    if (ids.length == 0) {
      getOptions("display")
      return
    }

    //console.log("IDS",ids)
    const idString = ids.join(",")
    //console.log("IDString",idString)
    
    getOnlineFriends(idString)

  }
  
  function getFriends() {
    //console.log("get FRIENDS")
    const urlStr = "https://lichess.org/api/rel/following"
    getLichessData(urlStr, lichessAccessToken,null, processJsonResponse) 
  
  }

  function processOnlineFriendsJsonResponse(json) {
    //console.log(" online friends callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    for (var loop = 0; loop < 2; loop++) {
      var onlineIndex = 0
      for (var i=0; i < json.length; i++) {
        var isOnline = false
        const name = json[i]['name']
        const id = json[i]['id']
        if (json[i].hasOwnProperty('online'))
          isOnline = (json[i]['online'] == true)
        
        if (loop == 0) {
          if (isOnline == false)
            continue
          //console.log("ONLINE ",id,name)

          const oneFriend = {
            index : onlineIndex,
            userid : id,
            name : name,
            radio : "" + onlineIndex
          }
          onlineFriends.value.push(oneFriend)

          if (onlineIndex == 0)
            optionDisplaySelected = "0"

          onlineIndex++
        }
        else {
          if (isOnline == true)
            continue
          //console.log("OFFLINE ",id,name)
          const oneFriend = {
            index : i,
            name : name
          }
          offlineFriends.value.push(oneFriend)
        }
      }
    }

    if (onlineFriends.value.length == 0) {
      statusString.value = t("No Online Friends")
    }
    else {
      optionDisplayArray = onlineFriends.value
      optionHeading = t("Select Online Friend")
      whichOptionIsGenericList = "friend"
      openGenericSingleListModal()
      getOptions("friend")
    }

  }

  function getOnlineFriends(idString) {
    const urlStr = "https://lichess.org/api/users/status?ids=" + idString
    getLichessData(urlStr, lichessAccessToken,null, processOnlineFriendsJsonResponse) 
  
  }
</script>

<style scoped>

.center {
  text-align: center;
}

.repselector-center-text {
    text-align: center;
    margin-bottom : 10px;
    font-style :italic;
  }

  .repselector-heading-color {
    background: #4c6ca0;
    color : white;
  }

  .btn-padding {
    padding: 50px;
    padding-left : 100px;
    padding-right : 100px;
  }
</style>